import { useProjectServiceUser } from "@lumanity/ui/projects";
import { useTeam } from "@/features/team/teamApi";

/**
 * Whether the signed-in user may change an output's draft: a project editor or
 * owner holding the Writer role (the backend enforces the same). `reason` says why not.
 */
export function useCanWrite(projectId: string, projectRole: string | undefined) {
  const me = useProjectServiceUser();
  const team = useTeam(projectId);
  if (!me.data || !team.data || !projectRole) return { canWrite: false, reason: null, isLoading: true };
  if (projectRole === "viewer") return { canWrite: false, reason: "You can view this draft; viewers can't change it.", isLoading: false };
  const member = team.data.members.find((m) => m.user_id === me.data.id);
  if (!member?.workflow_roles.includes("writer")) {
    return {
      canWrite: false,
      reason: "Only Writers can change the draft. A project owner can give you the Writer role in the project's Team panel.",
      isLoading: false,
    };
  }
  return { canWrite: true, reason: null, isLoading: false };
}
